import React, { useRef, useState } from "react";
import { Upload, X, Loader2, Image as ImageIcon } from "lucide-react";
import { uploadImage, resolveImage } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";
import { Button } from "../ui/button";

const JpegUploader = ({ value, onChange, label = "Görsel", aspect = "aspect-video" }) => {
  const { toast } = useToast();
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handlePick = () => inputRef.current?.click();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const name = file.name.toLowerCase();
    if (!file.type.toLowerCase().includes("jpeg") && !file.type.toLowerCase().includes("jpg") && !name.endsWith(".jpg") && !name.endsWith(".jpeg")) {
      toast({ title: "Geçersiz dosya", description: "Sadece JPEG/JPG yükleyebilirsiniz." });
      e.target.value = "";
      return;
    }
    try {
      setBusy(true);
      const data = await uploadImage(file);
      onChange(data.url);
      toast({ title: "Yüklendi", description: "Görsel başarıyla yüklendi." });
    } catch (err) {
      toast({ title: "Hata", description: err?.response?.data?.detail || err.message });
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const preview = value ? resolveImage(value) : "";

  return (
    <div className="space-y-2">
      {label && <label className="text-xs font-semibold text-slate-700">{label}</label>}
      <div className={`relative ${aspect} w-full rounded-lg overflow-hidden border-2 border-dashed border-slate-300 bg-slate-50 group`}>
        {preview ? (
          <>
            <img src={preview} alt="preview" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 hover:bg-white shadow flex items-center justify-center text-red-600"
              aria-label="Kaldır"
            >
              <X className="w-4 h-4" />
            </button>
          </>
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center text-slate-400">
            <ImageIcon className="w-8 h-8 mb-2" />
            <span className="text-xs">Görsel yok</span>
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/jpg,.jpg,.jpeg"
          onChange={handleFile}
          className="hidden"
        />
        <Button type="button" variant="outline" size="sm" onClick={handlePick} disabled={busy} className="gap-2">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {busy ? "Yükleniyor..." : "JPEG Seç"}
        </Button>
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="veya görsel URL'i yapıştır"
          className="flex-1 px-3 py-1.5 text-xs border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#b91c1c]/30"
        />
      </div>
    </div>
  );
};

export default JpegUploader;
